import apiError from './api-error'
import success from './success'

const alert = {
  apiError,
  success,
}

export default alert
